import { useEffect, useRef } from 'react'

export function useDebouncedEffect(callback: any, delay: any, deps: any) {
  const firstUpdate = useRef(true)

  const depsValues = deps instanceof Array ? deps : [deps]

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }
    const handler = setTimeout(() => {
      callback()
    }, delay)

    return () => {
      clearTimeout(handler)
    }
    /* eslint-disable */
  }, [delay, callback, ...depsValues])
}
